
document.addEventListener('DOMContentLoaded', () => {
    const items = document.querySelectorAll('.Loadings__single');
    const loader = document.querySelector('.Loadings__loader');

    if (!items.length || !loader) return;

    let currentIndex = 0;
    let interval = null;
    const duration = 12000;

    function activate(index) {
        items.forEach(item => item.classList.remove('active'));
        items[index].classList.add('active');

        resetLoader();
        currentIndex = index;
    }

    function resetLoader() {
        loader.classList.add('reset');

        // wymuszenie restartu animacji
        void loader.offsetWidth;

        loader.classList.remove('reset');
    }

    function startInterval() {
        clearInterval(interval);
        interval = setInterval(() => {
            currentIndex = (currentIndex + 1) % items.length;
            activate(currentIndex);
        }, duration);
    }

    // start
    activate(0);
    startInterval();

    // kliknięcie
    items.forEach((item, index) => {
        const heading = item.querySelector('.heading');
        if (!heading) return;

        heading.addEventListener('click', () => {
            activate(index);
            startInterval();
        });
    });
});

